import { useEffect, useState } from 'react';

/**
 * The media query for the width where the history pages widen their shell
 * for the table. The width is `$vads-breakpoint-desktop-lg` in css-library's
 * `tokens/scss/variables.scss`, which `ClaimantSubmissionHistoryPage.scss`
 * widens on, so a token bump lands in both places.
 *
 * @type {string}
 */
export const LAPTOP_MEDIA_QUERY = '(min-width: 1201px)';

/**
 * @returns {boolean} Whether the viewport matches `LAPTOP_MEDIA_QUERY`. A
 *   browser without `matchMedia` counts as laptop width.
 */
const matchLaptop = () =>
  typeof window.matchMedia !== 'function' ||
  window.matchMedia(LAPTOP_MEDIA_QUERY).matches;

/**
 * Tracks whether the viewport is laptop width or wider.
 *
 * @returns {boolean}
 */
export const useLaptopViewport = () => {
  const [isLaptop, setIsLaptop] = useState(matchLaptop);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(LAPTOP_MEDIA_QUERY);
    const update = event => setIsLaptop(event.matches);
    setIsLaptop(query.matches);
    // Safari before 14 has only the deprecated addListener.
    if (typeof query.addEventListener !== 'function') {
      query.addListener(update);
      return () => query.removeListener(update);
    }
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return isLaptop;
};
